import { Controller } from "@hotwired/stimulus"

// Keeps a per-todo "Assigned to" <select> in sync with a single shared
// options template (id="custom_todo_assignee_options_template")
// rendered once on the figure edit page. After a collaborator is added
// or removed the CustomFigureCollaborationsController emits a
// turbo_stream.replace targeting that template; the parent
// #custom_todo_assignee_options_carrier sees its children swapped,
// this controller's MutationObserver fires, and the select rebuilds
// its options.
//
// The currently-selected value is preserved when that user /
// collaborator still exists. When it was removed the value falls back
// to "" (Unassigned) and a `change` event is dispatched so any
// surrounding inline-editor/dirty-state can react.
const TEMPLATE_ID = "custom_todo_assignee_options_template"

export default class extends Controller {
  connect() {
    const template = document.getElementById(TEMPLATE_ID)
    const parent = template?.parentElement
    if (!parent) return

    this._observer = new MutationObserver(() => this._sync())
    this._observer.observe(parent, { childList: true })
  }

  disconnect() {
    this._observer?.disconnect()
    this._observer = null
  }

  _sync() {
    const template = document.getElementById(TEMPLATE_ID)
    if (!template) return

    const previousValue = this.element.value
    this.element.innerHTML = template.innerHTML

    const stillExists = Array.from(this.element.options)
      .some((option) => option.value === previousValue)

    if (stillExists) {
      this.element.value = previousValue
    } else {
      this.element.value = ""
      this.element.dispatchEvent(new Event("change", { bubbles: true }))
    }
  }
}
